import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-evidence-list-view',
  templateUrl: './evidence-list-view.component.html',
  styleUrls: ['./evidence-list-view.component.scss'],
})
export class EvidenceListViewComponent implements OnInit, OnChanges {
  @Input() evidenceData: any[] = [];

  @Input() isLoading: boolean = false;

  @Input() noEvidenceMessage: string = 'No evidence found';

  @Input() tableColumnObject: string[] = [];

  @Input() evidenceType: string;

  @Input() tableKeys: any = {};

  @Output() evidenceClick = new EventEmitter<number>();

  dataSource: any[] = [];

  constructor() {}

  ngOnInit(): void {
    this.updateDataSource();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['evidenceData']) {
      this.updateDataSource();
    }
  }

  private updateDataSource(): void {
    this.dataSource = this.evidenceData || [];
  }

  onRowClick(index: number): void {
    this.evidenceClick.emit(index);
  }

  getDisplayedColumns(): string[] {
    return [...this.tableColumnObject, 'actions'];
  }
}
